import axios from 'axios'
import { API_BASE_URL } from '../globalVar'

let baseUrl = API_BASE_URL
//let baseUrl = process.env.VUE_APP_API_BASE_URL

export const reportsApiService = {
    getPagenated,
    getDownloadKey,
    getReportTypes
}

function getPagenated(payload) {
    return axios.post(baseUrl + '/api/admin/v1/reports/select', payload)
}

function getDownloadKey() {
    return axios.get(baseUrl + '/api/admin/v1/reports/key')
}

function getReportTypes() {
    return axios.get(baseUrl + '/api/admin/v1/reports/types')
}